import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReplaceReservationWarning from 'tenants/sealink/replace_reservation_warning';

const WarningModal = ({ product }) => {
  const history = useHistory();

  const closeOffcanvasRef = useRef(
    document.querySelector(
      '#experience-off-canvas [data-bs-dismiss="offcanvas"]'
    )
  );

  const handleModalClose = () => {
    closeOffcanvasRef.current?.click();
    history.push('/');
  };

  return (
    <ReplaceReservationWarning
      scene="experience"
      onClose={handleModalClose}
      product={product}
    />
  );
};

WarningModal.propTypes = {
  product: PropTypes.shape({
    hasFerry: PropTypes.bool.isRequired,
    hasAccommodation: PropTypes.bool.isRequired,
  }),
};

export default WarningModal;
